import { atom } from 'jotai';

export const welcomeModalOpenAtom = atom<boolean>(false);
